var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "To_Do_List_1_",
    transform: "translate(942.332 431.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    d: "M80.734,52H87.8a3.534,3.534,0,0,1,3.533,3.533v31.8A3.534,3.534,0,0,1,87.8,90.868H59.533A3.534,3.534,0,0,1,56,87.335v-31.8A3.534,3.534,0,0,1,59.533,52H73.667",
    transform: "translate(-56 -49.092)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7140",
    "data-name": "Path 7140",
    d: "M136,133.767l1.767,1.767L141.3,132",
    transform: "translate(-128.933 -122.026)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7141",
    "data-name": "Path 7141",
    d: "M136,253.767l1.767,1.767L141.3,252",
    transform: "translate(-128.933 -231.425)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    "data-name": "Path 7142",
    d: "M136,373.767l1.767,1.767L141.3,372",
    transform: "translate(-128.933 -340.825)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    y1: 6,
    transform: "translate(17.668 0.121)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 11,
    transform: "translate(17.668 14.121)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 11,
    transform: "translate(17.668 24.121)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 11,
    transform: "translate(17.668 34.121)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.4342fa04b7842c03f21cf402070bdb84.svg";
export { ForwardRef as ReactComponent };